/**
 * Valid suggestion types for build mode suggestions
 */
export enum BuildModeSuggestionType {
  SETUP_ZAPS = "Set up my Zap workflows",
  CREATE_AUTH = "Create new App Connection",
  LEAD_GENERATION = "Lead Generation System",
  CUSTOMER_SUPPORT = "Customer Support Automation",
  ECOMMERCE_ORDER = "E-commerce Order Processing",
  TOUR_MY_CANVAS = "Take a tour of my Canvas",
  EXPLAIN_MY_CANVAS = "Explain My Canvas",
  WHAT_CAN_COPILOT_DO = "What can Copilot do?",
  ZAPIER_COMMON_USE_CASES = "What are common use cases for Zapier?",
  HELP_BUILD_MY_CANVAS = "Help build my canvas",
  LEARN_ABOUT_CANVAS = "Learn about Canvas",
  ZAPIER_FOR_BEGINNERS = "Zapier for beginners",
}
